class OpenCartiButton extends HTMLElement {
    constructor() {
        super();

        const button = document.createElement("div");
        button.setAttribute("class", "opencartibtnGhost");
        button.setAttribute(
            "class",
            "button button--full-width button--secondary"
        );
        button.setAttribute("role", "button");
        button.setAttribute("type", "button");
        button.innerHTML = "View Cart";

        this.appendChild(button);
        this.closeButton = button;

        // Agregamos el evento de clic al botón
        this.closeButton.onclick = this.showCloseButton.bind(this);
    }

    showCloseButton() {
        if (this.closeButton.classList.contains("visible_close_btn")) {
            this.closeButton.classList.remove("visible_close_btn");
            console.log('eliminar clase');
            window.upcartCloseCart();

            //alert('Test 4');
            /*setTimeout(function() {
              let $upcartFooter = $('.upcart-footer');
              let $upcartUpsell = $('.upcart-upsells-module');
              $upcartFooter.addClass('fixed');
              $upcartUpsell.addClass('fixed');
            }, 800);*/
          setTimeout(function() {
            $('.upcart-footer').removeClass('fixed');
            $('.upcart-upsells-module').removeClass('fixed');
          }, 400);
        } else {
            this.closeButton.classList.add("visible_close_btn");
            console.log('agregar clase');
            // Aquí puedes incluir el resto de tu lógica para abrir el carrito y modificar el contenido
            window.upcartModifyCart = function (cart) {
                let upsellCarousel =
                    document.getElementById("up-upsell-carousel");
                let strongElementTitle = upsellCarousel.querySelector("strong");
                if (cart.total_price >= 10000) {
                    strongElementTitle.innerHTML =
                        "Life’s Short, Add More Candy!";
                } else {
                    strongElementTitle.innerHTML =
                        "Add More Sweet Treats to Get Your Free Shipping!";
                }
                return cart;
            };

            window.upcartOnCartOpened = function (cart) {
              $.ajax({
                url: "/cart.js",
                type: "GET",
                dataType: "json",
                success: function (cartData) {
                    window.upcartModifyCart(cartData);
                },
                error: function (xhr, status, error) {
                    console.error("Failed to fetch cart data:", error);
                },
              });

              $("open-carti-button .button").removeClass('visible_close_btn');
              console.log('eliminar clase 2');

                setTimeout(function() {
                    var scrollHeight = $('#CartPopup').prop('scrollHeight');
                    var height = $('#CartPopup').height() - 1;

                    if (scrollHeight > height) {
                      $('.upcart-footer').addClass('fixed');
                      $('.upcart-upsells-module').addClass('fixed');
                    } else {
                      console.log('#CartPopUp can not scroll.');
                    }
                    isFixed = true;
                }, 200);
                console.log('Open 5');
            };

            let closeButtonB = document.querySelector("#open-carti");
            closeButtonB.classList.add("visible_close_btn");

            window.upcartOpenCart();
            window.upcartOnCartOpened();
        }
    }
}

customElements.define("open-carti-button", OpenCartiButton);
